export default {
    _lists: null,
    _buttons: null,
    _listClass: null,
    _buttonClass: null,

    init() {
        this._lists = document.querySelectorAll('[data-collapse--target]');
        this._buttons = document.querySelectorAll('[data-collapse--source]');
        const privacyCheckBox = document.querySelectorAll('.form__privacy');
        if (!(this._lists && this._buttons)) {
            return;
        }
            
        for (const button of this._buttons) {
            button.addEventListener(('click'), () => {
                this._buttonClass = button.classList[0];
                const loop = button.parentNode.getAttribute('data-loop');
                for (const list of this._lists) {
                    if (list.parentNode ==  button.parentNode && list.parentNode.getAttribute('data-loop') === loop) {
                        this._listClass = list.classList[0];
                        if (button.classList.contains(this._buttonClass + '--active')) {
                            button.classList.remove(this._buttonClass + "--active");
                            list.classList.remove(this._listClass + "--active");
                        } else {
                            button.classList.add(this._buttonClass + "--active");
                            list.classList.add(this._listClass + "--active");
                        }

                        for (const checkbx of privacyCheckBox) {
                            const inputfld = checkbx.querySelector("input[type='checkbox']");
                            if (inputfld) {
                                let parnt = inputfld.parentElement;
                                parnt.innerHTML = `<div>Ja, jeg godtar at Istad Kraft AS bruker informasjonen jeg har oppgitt som beskrevet samt i  
                            <a target="_blank" href=${siteUrl}/personvern> personvernerklÃ¦ringen</a>  vÃ¥r</div>`;
                                parnt.append(inputfld);
                            }
                        }
                    }
                }
            });
        }
    }
}